import { Link } from "react-router-dom";
import GoogleSignInButton from "../../components/auth/GoogleSignInButton";
import { UserPlus, ArrowLeft } from "lucide-react";

export const Register = () => {
  return (
    <div
      className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8"
      style={{ backgroundColor: "#faf9f5" }}
    >
      <div className="max-w-md w-full space-y-8">
        {/* Logo/Brand Section */}
        <div className="text-center">
          <div
            className="mx-auto h-16 w-16 rounded-2xl flex items-center justify-center shadow-lg mb-4"
            style={{
              background: "linear-gradient(135deg, #c96442 0%, #ea580c 100%)",
            }}
          >
            <UserPlus className="w-10 h-10 text-white" />
          </div>
          <h2 className="text-4xl font-extrabold text-gray-900 mb-2">
            Join Koflip Today
          </h2>
          <p className="text-gray-600">
            Create your account to start calculating property values
          </p>
        </div>

        {/* Main Card */}
        <div className="bg-white rounded-2xl shadow-lg p-8">
          {/* Google Sign-In Button */}
          <GoogleSignInButton text="Sign up with Google" />

          {/* Divider */}
          <div className="relative my-6">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-200"></div>
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-4 bg-white text-gray-500">
                Already have an account?
              </span>
            </div>
          </div>

          {/* Login Link */}
          <div className="text-center">
            <Link
              to="/login"
              className="inline-flex items-center justify-center w-full h-12 px-6 font-medium rounded-xl transition-all transform hover:scale-[1.01] hover:opacity-90"
              style={{ color: "#667eea", backgroundColor: "#f0f0ff" }}
            >
              <ArrowLeft className="mr-2 w-5 h-5" />
              Sign in to existing account
            </Link>
          </div>
        </div>

        {/* Footer */}
        <p className="text-center text-sm text-gray-500">
          By creating an account, you agree to our{" "}
          <a
            href="#"
            className="font-medium hover:opacity-80"
            style={{ color: "#667eea" }}
          >
            Terms of Service
          </a>{" "}
          and{" "}
          <a
            href="#"
            className="font-medium hover:opacity-80"
            style={{ color: "#667eea" }}
          >
            Privacy Policy
          </a>
        </p>
      </div>
    </div>
  );
};
